export default {
  preload: [],
  classes: {}
}